import { render, staticRenderFns } from "./update-bank-account-form.vue?vue&type=template&id=5a664d7e&scoped=true&"
import script from "./update-bank-account-form.vue?vue&type=script&lang=js&"
export * from "./update-bank-account-form.vue?vue&type=script&lang=js&"
import style0 from "./update-bank-account-form.vue?vue&type=style&index=0&lang=css&"
import style1 from "./update-bank-account-form.vue?vue&type=style&index=1&id=5a664d7e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a664d7e",
  null
  
)

export default component.exports